import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AddLocalDevApp from 'features/apps/add-local-dev-app/components';
import { Spinner } from 'commons/components/spinner';
import { Box, Flex } from '@sparrowengg/twigs-react';
import { devPortalServices } from 'commons/services';

const EditLocalDevApp = () => {
  const params = useParams();
  const [app, setApp] = useState<any>();
  const [loading, setLoading] = useState(false);
  const convertToYouTubeURL = (embedUrl: string): string => {
    const embedRegex = /\/embed\/([^/?]+)/;
    const match = embedUrl?.match(embedRegex);
    if (match && match[1]) {
      return `https://www.youtube.com/watch?v=${match[1]}`;
    } else {
      return embedUrl;
    }
  };

  const fetchSingleApp = async (id: string) => {
    setLoading(true);
    try {
      const response = await devPortalServices.getSingleApp(id);
      response.videoUrl = convertToYouTubeURL(response?.videoUrl);
      setApp(response);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSingleApp(`${params.id}`);
  }, [params?.id]);

  return (
    <>
      {loading ? (
        <Flex
          alignItems="center"
          justifyContent="center"
          css={{ width: '100%', height: 'calc(100vh - 64px)' }}
        >
          <Spinner size="md" />
        </Flex>
      ) : (
        <Box css={{ height: 'calc(100vh - 72px)', overflowY: 'auto' }}>
          <AddLocalDevApp app={app} />
        </Box>
      )}
    </>
  );
};

export default EditLocalDevApp;
